// extracted by mini-css-extract-plugin
export default {"ratingInfo":"TrustpilotFooter__ratingInfo-Ue__","set1":"TrustpilotFooter__set1-dG4z"};